export const isUndefined = (value: any) => typeof value === 'undefined';
